import { InputLabel, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IInputText } from "src/types/atoms";
const InputText = ({
  label,
  name,
  type = "text",
  placeholder = "",
  register = {},
  helperText = "",
  disabled = false,
  simpleHelperText = false,
  autoFocus = false,
  sx
}: IInputText) => {
  const classes = {
    root: {
      color: grey[900],
      marginBottom: 0.5
    },
    helperText: {
      color: grey[600],
      fontWeight: 400,
      fontSize: ".8rem",
      textAlign: "right"
    }
  };
  return <>
      <InputLabel htmlFor={name} sx={classes.root}>
        {label}
      </InputLabel>
      <TextField id={name} variant="outlined" type={type} placeholder={placeholder} disabled={disabled} autoComplete="off" fullWidth {...register} helperText={helperText} FormHelperTextProps={{
      sx: simpleHelperText ? classes.helperText : {}
    }} autoFocus={autoFocus} sx={sx} />
    </>;
};
export default InputText;